import type { Project } from '../types/content'

export const projects: Project[] = [
  {
    slug: 'bhoomi-coffee',
    client: 'Bhoomi Coffee Roasters',
    clientType: 'Speciality roaster · Shopify',
    headline: 'A storefront that sells the roast, not the discount.',
    problem: 'A decade of wholesale reputation is invisible online, so the shop competes on price.',
    outcome: 'Target outcome: full-margin orders instead of code-driven ones',
    year: '2026 — concept',
    category: 'Web',
    tags: ['Self-initiated concept', 'E-commerce', 'Shopify'],
    isConcept: true,
    image:
      'https://cdn.magicpatterns.com/patterns/generated-images/05ead7ef-cadb-40f9-8b28-e5da65bcdd07.jpg',
    alt: 'An unbranded coffee pouch, a tasting cup and roasted beans arranged over warm off-white and muted terracotta project boards',
    screenshot:
      'https://cdn.magicpatterns.com/patterns/generated-images/20c6d4d2-2061-44c7-a9d9-67d32b179930.jpg',
    screenshotAlt: 'Full-page website design concept for Bhoomi Coffee Roasters',
  },
  {
    slug: 'deshmukh-rao',
    client: 'Deshmukh & Rao Associates',
    clientType: 'Boutique law firm · Webflow',
    headline: 'Twelve years of case history, finally legible.',
    problem: 'Enquiries arrive cold because nothing on a firm’s site proves it has done the work before.',
    outcome: 'Target outcome: credibility established before the first call',
    year: '2026 — concept',
    category: 'Web',
    tags: ['Self-initiated concept', 'Content strategy', 'Webflow'],
    isConcept: true,
    image:
      'https://cdn.magicpatterns.com/patterns/generated-images/08eec00c-60ec-404e-9020-f76da22675fa.jpg',
    alt: 'A restrained law-firm website concept, a closed black notebook and a fountain pen arranged on warm off-white paper',
    screenshot:
      'https://cdn.magicpatterns.com/patterns/generated-images/ce6aec35-dc35-4009-b823-5b66ea340d3c.jpg',
    screenshotAlt: 'Full-page website design concept for Deshmukh & Rao Associates',
  },
  {
    slug: 'prana-physio',
    client: 'Prana Physiotherapy',
    clientType: 'Two-clinic practice · Framer',
    headline: 'Booking in three taps, from the waiting room or the auto.',
    problem: 'Reception fields booking calls all morning because the online form is longer than the appointment.',
    outcome: 'Target outcome: a booking finished in under a minute',
    year: '2026 — concept',
    category: 'Product',
    tags: ['Self-initiated concept', 'Booking flow', 'Framer'],
    isConcept: true,
    image:
      'https://cdn.magicpatterns.com/patterns/generated-images/eed02049-dd38-4e35-8393-1d6a6a35e071.jpg',
    alt: 'A mobile booking-flow concept, a folded clinic towel and a resistance band arranged on warm off-white paper',
    screenshot:
      'https://cdn.magicpatterns.com/patterns/generated-images/89e09aae-0a93-4a2c-818d-7373b892d666.jpg',
    screenshotAlt: 'Full-page booking website design concept for Prana Physiotherapy',
  },
  {
    slug: 'meridian-architects',
    client: 'Meridian Architects',
    clientType: 'Identity system · Print and web',
    headline: 'An identity for a practice that builds quietly and well.',
    problem: 'Small architecture practices present themselves with portfolios, not positions — so they all read the same.',
    outcome: 'Target outcome: a practice that can charge for judgement, not drawings',
    year: '2026 — concept',
    category: 'Branding',
    tags: ['Self-initiated concept', 'Identity', 'Art direction'],
    isConcept: true,
    image:
      'https://cdn.magicpatterns.com/patterns/generated-images/19203172-3464-468e-b358-e8387d4b2ae8.jpg',
    alt: 'Architectural identity boards, restrained material swatches and a black pencil arranged on warm off-white paper',
    screenshot:
      'https://cdn.magicpatterns.com/patterns/generated-images/7d34f9ae-d0fb-4182-9de6-2aa2087dff32.jpg',
    screenshotAlt: 'Full-page website design concept for Meridian Architects',
  },
  {
    slug: 'northpulse-dashboard',
    client: 'Northpulse',
    clientType: 'SaaS product · Dashboard UI',
    headline: 'A reporting tool that answers the question before you ask it.',
    problem: 'Analytics products bury the one number a founder checks daily under sixteen they never open.',
    outcome: 'Target outcome: first answer visible in under five seconds',
    year: '2026 — concept',
    category: 'Product',
    tags: ['Self-initiated concept', 'Dashboard UI', 'Design system'],
    isConcept: true,
    image:
      'https://cdn.magicpatterns.com/patterns/generated-images/d0e534c6-543a-4962-9563-25304200caed.jpg',
    alt: 'An unbranded tablet and abstract analytics interface boards arranged on a warm off-white desk',
    screenshot:
      'https://cdn.magicpatterns.com/patterns/generated-images/ec5ab3cb-7452-4fc2-abec-8ce3e6ee521f.jpg',
    screenshotAlt: 'Full-page dashboard interface design concept for Northpulse',
  },
]
